var ColumnStyle = {};

export { ColumnStyle as default };
